import script from "./upload-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-widget.vue?vue&type=script&setup=true&lang=js"

import "./upload-widget.vue?vue&type=style&index=0&id=28b09751&lang=scss&scoped=true"

import exportComponent from "D:\\code\\form_designer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b09751"]])

export default __exports__